/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

const messages = defineMessages({
  mobileTitle: {
    id: `navigation.mobile-title`,
    defaultMessage: `Navigate`,
  },
  deployments: {
    id: `navigation.deployments`,
    defaultMessage: `Deployments`,
  },
  activityFeed: {
    id: `navigation.activity-feed`,
    defaultMessage: `Activity feed`,
  },
  platform: {
    id: `navigation.platform`,
    defaultMessage: `Platform`,
  },
  clusterManage: {
    id: `navigation.cluster.manage`,
    defaultMessage: `Manage`,
  },
  loggingMonitoring: {
    id: `navigation.deployments.logging-monitoring`,
    defaultMessage: `Logs and metrics`,
  },
  deploymentEdit: {
    id: `navigation.deployment.edit`,
    defaultMessage: `Edit`,
  },
  deploymentElasticsearch: {
    id: `navigation.deployment.elasticsearch`,
    defaultMessage: `Elasticsearch`,
  },
  deploymentElasticsearchEdit: {
    id: `navigation.deployment.elasticsearch.edit`,
    defaultMessage: `Edit`,
  },
  deploymentActivity: {
    id: `navigation.deployment.activity`,
    defaultMessage: `Activity`,
  },
  deploymentSecurity: {
    id: `navigation.deployment.security`,
    defaultMessage: `Security`,
  },
  deploymentOperations: {
    id: `navigation.deployment.operations`,
    defaultMessage: `Operations`,
  },
  deploymentMetrics: {
    id: `navigation.deployment.performance`,
    defaultMessage: `Performance`,
  },
  deploymentHeapDumps: {
    id: `navigation.deployment.heapDumps`,
    defaultMessage: `Heap dumps`,
  },
  clusterKibanaEdit: {
    id: `navigation.cluster.kibana.edit`,
    defaultMessage: `Edit`,
  },
  clusterSnapshots: {
    id: `navigation.cluster.snapshots`,
    defaultMessage: `Snapshots`,
  },
  apiConsole: {
    id: `navigation.api.console`,
    defaultMessage: `API console`,
  },
  platformAdminconsoles: {
    id: `navigation.platform.adminconsoles`,
    defaultMessage: `Admin consoles`,
  },
  platformContainerSets: {
    id: `navigation.platform.container-sets`,
    defaultMessage: `Container sets`,
  },
  platformHosts: {
    id: `navigation.platform.hosts`,
    defaultMessage: `Hosts`,
  },
  platformHostsAllocators: {
    id: `navigation.platform.hosts.allocators`,
    defaultMessage: `Allocators`,
  },
  platformHostsProxies: {
    id: `navigation.platform.hosts.proxies`,
    defaultMessage: `Proxies`,
  },
  platformHostsControlPlanes: {
    id: `navigation.platform.hosts.control-planes`,
    defaultMessage: `Control planes`,
  },
  platformHost: {
    id: `navigation.platform.host`,
    defaultMessage: `Host`,
  },
  platformHostAllocators: {
    id: `navigation.platform.host.allocator`,
    defaultMessage: `Allocator`,
  },
  platformHostProxies: {
    id: `navigation.platform.host.proxy`,
    defaultMessage: `Proxy`,
  },
  platformHostControlPlanes: {
    id: `navigation.platform.host.control-plane`,
    defaultMessage: `Control plane`,
  },
  platformElasticStack: {
    id: `navigation.platform.elastic-stack`,
    defaultMessage: `Elastic Stack`,
  },
  platformTrustManagement: {
    id: `navigation.platform.trust-management`,
    defaultMessage: `Trust Management`,
  },
  platformRepositories: {
    id: `navigation.platform.repositories`,
    defaultMessage: `Repositories`,
  },
  platformSettings: {
    id: `navigation.platform.settings`,
    defaultMessage: `Settings`,
  },
  platformSecurity: {
    id: `navigation.platform.security`,
    defaultMessage: `Security`,
  },
  platformSummary: {
    id: `navigation.platform.summary`,
    defaultMessage: `Summary`,
  },
  organizations: {
    id: `navigation.organizations`,
    defaultMessage: `Organizations`,
  },
  saasUsers: {
    id: `navigation.saas-users`,
    defaultMessage: `Users`,
  },
  createSaasUser: {
    id: `navigation.create-saas-user`,
    defaultMessage: `Create`,
  },
  platformTopology: {
    id: `navigation.platform.topology-link`,
    defaultMessage: `Templates`,
  },
  users: {
    id: `navigation.users`,
    defaultMessage: `Users`,
  },
  userApiKeys: {
    id: `navigation.user-api-keys`,
    defaultMessage: `API keys`,
  },
  managementUsers: {
    id: `navigation.management.users`,
    defaultMessage: `Native users`,
  },
  managementApiKeys: {
    id: `navigation.management.api-keys`,
    defaultMessage: `API keys`,
  },
  managementAuthenticationProviders: {
    id: `navigation.management.authentication-providers`,
    defaultMessage: `Authentication providers`,
  },
  beta: {
    id: `navigation.management.beta-feature`,
    defaultMessage: `Beta`,
  },
  betaDescription: {
    id: `navigation.management.beta-feature.description`,
    defaultMessage: `This feature is not yet GA. Please help us by reporting any issues!`,
  },
  createDeployment: {
    id: `navigation.deployments.create-deployment`,
    defaultMessage: `Create deployment`,
  },
  advancedEdit: {
    id: `navigation.deployment.edit.advanced-stack-deployment-edit`,
    defaultMessage: `Advanced`,
  },
  advancedEsEdit: {
    id: `navigation.deployment.edit.advanced-es`,
    defaultMessage: `Advanced Elasticsearch`,
  },
  advancedKibanaEdit: {
    id: `navigation.deployment.edit.advanced-kibana`,
    defaultMessage: `Advanced Kibana`,
  },
  advancedApmEdit: {
    id: `navigation.deployment.edit.advanced-apm`,
    defaultMessage: `Advanced APM`,
  },
  createRepository: {
    id: `navigation.platform.repositories.create`,
    defaultMessage: `Create`,
  },
  deploymentMonitoring: {
    id: `navigation.deployment-monitoring`,
    defaultMessage: `Monitoring`,
  },
  healthStatus: {
    id: `navigation.deployment.healthStatus`,
    defaultMessage: `Health`,
  },
})

export default messages
